<template>
  <div class="right-tab">
    <!-- 左侧阴影 -->
    <img class="left-yy" src="../assets/images/v4_yy1.png" alt="" />
    <el-tabs
      v-model="editableTabsValue"
      type="card"
      closable
      @tab-remove="removeTab"
      @tab-click="selectTab"
      style="max-width: 830px"
    >
      <el-tab-pane
        :key="item.name"
        v-for="item in editableTabs"
        :label="item.title"
        :name="item.name"
      ></el-tab-pane>
    </el-tabs>
    <!-- 右侧阴影 -->
    <img
      v-if="rightTabWidth > 780"
      class="right-yy"
      src="../assets/images/v4_yy1.png"
      alt=""
    />
    <!-- 关闭菜单 -->
    <div class="close-all" v-if="editableTabs.length > 0">
      <i class="el-icon-close" @click="handleCloseOther"></i>
      <!-- <el-dropdown>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="handleCloseAll"
            >关闭所有</el-dropdown-item
          >
          <el-dropdown-item @click.native="handleCloseOther"
            >关闭其他</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown> -->
    </div>
  </div>
</template>
  <script>
export default {
  data() {
    return {
      editableTabsValue: "0",
      editableTabs: [
        // {
        //   title: "首页",
        //   name: "1",
        //   content: "/auth/security/getLoginList"
        // },
      ],
      tabIndex: 0,
      menuActiveRightItem: "", //当前选中菜单数据
      rightTabWidth: null,
    };
  },
  computed: {
    menus() {
      return this.$store.state.baseData.menus;
    },
  },
  methods: {
    addTab(targetItem, type) {
      this.getRightTabWidth();
      // 包括padding border
      if (type === "Refresh") {
        let tabs = sessionStorage.getItem("editableTabs")
          ? JSON.parse(sessionStorage.getItem("editableTabs"))
          : [];
        // 刷新或切换语言，tab获取对应语言
        let newArr = [];
        tabs.map((item) => {
          newArr.push({
            title: this.getActiveMenusLan(item.content),
            name: item.name,
            content: item.content,
          });
        });
        this.editableTabs = newArr;
        sessionStorage.setItem("editableTabs", JSON.stringify(newArr));
      }

      if (this.$route.path != "/") {
        this.getActiveMenus();
        let tabs = sessionStorage.getItem("editableTabs")
          ? JSON.parse(sessionStorage.getItem("editableTabs"))
          : [];
        this.editableTabs = tabs;
        let [hasTab, tabIndex] = [false];
        var rIndex = 0;
        tabs.forEach((tab, index) => {
          if (this.menuActiveRightItem.atName == tab.content) {
            hasTab = true;
            tabIndex = tab.name;
            rIndex = index;
          }
        });

        if (!hasTab) {
          let newTabName;
          if (this.editableTabs.length == 0) {
            newTabName = "1";
          } else {
            newTabName =
              parseInt(this.editableTabs[this.editableTabs.length - 1].name) +
              1 +
              "";
          }
          this.editableTabs.push({
            title: this.menuActiveRightItem.atDes,
            name: newTabName,
            content: this.menuActiveRightItem.atName,
          });
          // 最多50个tab，超出删除前边
          if (this.editableTabs.length > 50) {
            let arr = this.editableTabs;
            arr.splice(1, this.editableTabs.length - 50);
            this.editableTabs = arr;
          }
          sessionStorage.setItem(
            "editableTabs",
            JSON.stringify(this.editableTabs)
          );
          this.editableTabsValue = newTabName;
        } else {
          tabs[rIndex].content = this.menuActiveRightItem.atName;
          sessionStorage.setItem("editableTabs", JSON.stringify(tabs));
          this.editableTabsValue = tabIndex;
        }
      }
    },
    removeTab(targetName) {
      let tabs = sessionStorage.getItem("editableTabs")
        ? JSON.parse(sessionStorage.getItem("editableTabs"))
        : [];
      let activeName = this.editableTabsValue;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
              this.$router.push(nextTab.content);
            } else {
              this.editableTabsValue = "0";
              this.editableTabs = [];
              this.tabIndex = 0;
              this.$router.push("/");
            }
          }
        });
      }
      this.editableTabsValue = activeName;
      this.editableTabs = tabs.filter((tab) => tab.name !== targetName);
      sessionStorage.setItem("editableTabs", JSON.stringify(this.editableTabs));
    },
    selectTab(targetName) {
      let routerKey = targetName.label;
      let tabs = this.editableTabs;
      tabs.forEach((tab, index) => {
        if (routerKey == tab.title) {
          this.editableTabsValue = ++index + "";
          this.$router.push(tab.content);
        }
      });
    },
    // 刷新获取面包屑选中菜单
    getActiveMenus() {
      const { meta } = this.$route;
      for (let key in this.menus.menuList) {
        this.deepMatchMenuIndexByPath(this.menus.menuList[key], meta.atName);
      }
    },
    // 刷新获取面包屑选中菜单
    deepMatchMenuIndexByPath(menuList, path) {
      return menuList.findIndex((menu) => {
        if (menu.atName === path) {
          this.menuActiveRightItem = menu; //右边当前页面url选中的atName
          sessionStorage.setItem("currentPageTitle", JSON.stringify(menu)); //存储当前页面标题
        }
        if (menu.child) {
          return this.deepMatchMenuIndexByPath(menu.child, path) !== -1;
        }
      });
    },
    // 获取面包屑个tab标题语言
    getActiveMenusLan(atName) {
      for (let key in this.menus.menuList) {
        this.deepMatchMenuIndexByPath(this.menus.menuList[key], atName);
      }
      return this.menuActiveRightItem.atDes;
    },
    // 关闭所有
    handleCloseAll() {
      let tabs = sessionStorage.getItem("editableTabs")
        ? JSON.parse(sessionStorage.getItem("editableTabs"))
        : [];
      tabs.map((item) => {
        if (item.name !== "1") {
          this.removeTab(item.name);
        }
      });
    },
    // 关闭其他
    handleCloseOther() {
      let tabs = sessionStorage.getItem("editableTabs")
        ? JSON.parse(sessionStorage.getItem("editableTabs"))
        : [];
      tabs.map((item) => {
        if (item.name !== "1") {
          if (item.name !== this.editableTabsValue) {
            this.removeTab(item.name);
          }
        }
      });
    },
    // 获取righttab宽度
    getRightTabWidth() {
      let rightTabWidth = document.querySelector(".right-tab");
      this.rightTabWidth = rightTabWidth.offsetWidth;
    },
  },
  mounted() {
    setTimeout(() => {
      this.getRightTabWidth();
    }, 900);
  },
};
</script>
  <style lang="scss">
.right-tab {
  .left-yy {
    position: absolute;
    left: -11px;
    top: -27px;
    height: 60px;
    width: 15px;
  }
  .right-yy {
    height: 33px;
    width: 15px;
    position: absolute;
    right: 88px;
    transform: rotate(180deg);
  }
  display: flex;
  .close-all {
    cursor: pointer;
    position: relative;
    top: 4px;
    right: -4px;
    .el-icon-close {
      font-size: 16px;
      padding: 6px;
      color: #93979b;
      &:hover {
        color: #095bec;
      }
      // padding-left: 15px;
      // border-left: 1px solid #e4e7ed;
    }
  }
}
@media (max-width: 1350px) {
  .right-tab {
    display: none;
  }
}
</style>
  